"use strict"

// Х о н е й п о т

$(document).on("turbolinks:load", function() {
  window.activate_extra_field()
})


window.activate_extra_field = function() {
  $("body").on("focus", ".surnamefield input", function(e) {
    $(this).blur()
  })

  const extra_fields = $(".extra_field")

  if (extra_fields.length == 0) {
    return null
  }

  extra_fields.each(function(index, element) {
    const extra_field = $(element)

    if (extra_field.next(".row.surnamefield").length > 0) {
      return null
    }

    const js_field = $("<input>", {
      type: "hidden",
      name: "extraname",
      value: "Зенон"
    })

    const html_field = `
      <div class="row surnamefield">
        <div class="col-3">
          <div class="wrap shred padded">
            <label class="required" for="surnamefield">Фамилия</label>
          </div>
        </div>
        <div class="col-9">
          <div class="wrap shred padded">
            <input type="text" value="" name="surname" id="surnamefield">
          </div>
        </div>
      </div>
    `

    extra_field.after(js_field)
    extra_field.after($(html_field))

    $(".surnamefield").css({
      position: "absolute",
      left: "-73284px",
      top: "auto",
      width: "1px",
      height: "1px",
      overflow: "hidden"
    })
  })
}
